// src/components/SQLStatement.tsx

import React, { useState } from 'react';
import { formatSQL } from '../utils/sqlFormatter';
import './SQLStatement.css';
import { IconCopy } from '@cimpress-technology/react-streamline-icons/lib';

interface SQLStatementProps {
  statement: string;
  executeSQLStatement: (event: any, promptId: string, sql: string) => void;
  SQLExecuted?: boolean;
}

const SQLStatement: React.FC<SQLStatementProps> = ({
  statement,
  executeSQLStatement,
  SQLExecuted = false,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(statement);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="sql-query-message">
      <div className="query-block-container">
        <button className="copy-button" onClick={handleCopy} title="Copy SQL">
          <IconCopy style={{ color: '#fff', height: '16px' }} />
          {copied ? 'Copied!' : 'Copy'}
        </button>
        <pre className="query-block">
          <code dangerouslySetInnerHTML={{ __html: formatSQL(statement) }} />
        </pre>
      </div>
    </div>
  );
};

export default SQLStatement;
